export default __webpack_public_path__ + "static/portray-2cd13c8cf085cfb70411735f83ccd324.jpg";